import { JSX } from "react";

const ProvidersByCountyDescription = (): JSX.Element => {
  return <>
    <p>
      The Providers By County card summarizes how your network is spread geographically at a county level.
      This view of the geographic footprint helps quickly identify where providers are concentrated and where there may be a limited network presence across various counties.
    </p>
    <p>
      Providers without a CountySSA value will be grouped as “Unknown.”
    </p>
  </>;
}

export { ProvidersByCountyDescription };